import React from 'react'
import * as ResourceIcon from '../Icon/Resource'
import Star from '../Icon/Star'

const changeTextColor = hexcolor => {
  if (!hexcolor) return 'white'
  var r = parseInt(hexcolor.substr(1, 2), 16)
  var g = parseInt(hexcolor.substr(3, 2), 16)
  var b = parseInt(hexcolor.substr(5, 2), 16)

  return (r * 299 + g * 587 + b * 114) / 1000 < 128 ? 'white' : 'black'
}

export default function Front({
  artistName,
  type,
  title = '',
  img,
  color = '#696969',
  rank = 0,
  style = {},
  ...props
}) {
  const textColor = changeTextColor(color)

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 540 850"
      style={{
        filter: 'drop-shadow(0px 0px 5px rgba(0,0,0,0.5))',
        ...style,
      }}
      {...props}
    >
      <def>
        <style type="text/css">
          @import url(https://fonts.googleapis.com/css?family=Noto+Sans+JP);
        </style>
      </def>
      <defs>
        <pattern id="img" width="1" height="1">
          <image
            preserveAspectRatio="xMidYMid slice"
            width="540"
            height="850"
            rx="30"
            ry="30"
            xlinkHref={img}
          />
        </pattern>
      </defs>
      <defs>
        <filter
          id="box-filter-heigher"
          filterUnits="objectBoundingBox"
          x="-50%"
          y="-50%"
          width="200%"
          height="200%"
        >
          <feDropShadow
            dx="0"
            dy="0"
            stdDeviation="20"
            floodColor="#000000"
            floodOpacity="0.1"
          />
        </filter>
      </defs>
      <defs>
        <filter
          id="box-filter-lower"
          filterUnits="objectBoundingBox"
          x="-50%"
          y="-50%"
          width="200%"
          height="200%"
        >
          <feDropShadow
            dx="0"
            dy="0"
            stdDeviation="20"
            floodColor="#000000"
            floodOpacity="0.1"
          />
        </filter>
      </defs>
      {img ? (
        <rect width="540" height="850" rx="30" ry="30" fill="url(#img)" />
      ) : (
        <rect width="540" height="850" rx="30" ry="30" fill="#E8E8E8" />
      )}
      <rect
        x="35"
        y="46"
        width="470"
        height="80"
        fill={color}
        opacity="0.8"
        rx="20"
        ry="20"
        filter="url(#box-filter-heigher)"
      />
      <rect
        x="35"
        y="698"
        width="470"
        height="106"
        fill={color}
        opacity="0.8"
        rx="20"
        ry="20"
        filter="url(#box-filter-lower)"
      />
      <text x="50%" y="100" textAnchor="middle" fontSize="32" fill={textColor}>
        {artistName}
      </text>
      <foreignObject
        fontWeight="700"
        fontSize="30"
        x="100"
        y="700"
        width="340"
        height="100"
        fontFamily="Noto Sans JP"
      >
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{ display: 'table', width: 340, height: 100 }}
        >
          <p
            style={{
              display: 'table-cell',
              textAlign: 'center',
              verticalAlign: 'middle',
              color: textColor,
              whiteSpace: 'pre-wrap',
              lineHeight: 1.2,
            }}
          >
            {title}
          </p>
        </div>
      </foreignObject>
      <ResourceIcon.Type type={type} width="88" height="88" x="14" y="657" />
      {[50, 70, 90, 110, 130].slice(0, rank).map((x, index) => (
        <Star
          key={index}
          x={x}
          y="784"
          color={textColor}
          isBlack={textColor === 'black'}
        />
      ))}
    </svg>
  )
}
